import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {I18n} from 'react-redux-i18n';
import {Clear} from '@material-ui/icons';
import {withStyles} from '@material-ui/core/styles';

import {EntitiesListWithViewModesCard} from '../index';
import {LoadingLayout} from '../../layouts-common';
import {widgetKeys} from '../../containers/OrganizationProfilesTab/constants';
import {ACCESS_RIGHTS} from '../../constants';
import {RightAvailability} from '../../containers/index';
import style from './style';

const rightAvailabilityMap = {
  buttonOrganizationProfileUnlink: [ACCESS_RIGHTS.ORGANIZATION_PROFILE_LINK],
};

class OrganizationProfilesTable extends Component {
  constructor(props) {
    super(props);
    this.actionsCellRenderer = (row) => (
      <RightAvailability accessRights={rightAvailabilityMap.buttonOrganizationProfileUnlink}>
        <div
          className={this.props.classes.organizationProfilesTable__cell_action}
          onClick={() => this.props.removeProfileFromOrganization(row.index)}
        >
          <Clear />
        </div>
      </RightAvailability>
    );
  }

  get fullScreenColumns() {
    return [
      {
        Header: I18n.t('organizations.profiles.table.headers.profile'),
        accessor: 'name',
        minWidth: 150,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.clientsTotal'),
        accessor: 'clientsTotal',
        minWidth: 80,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.clientsOnline'),
        accessor: 'clientsOnline',
        minWidth: 80,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.clientsOffline'),
        accessor: 'clientsOffline',
        minWidth: 80,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.requestsAllowed'),
        accessor: 'requestsAllowed',
        minWidth: 100,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.requestsBlocked'),
        accessor: 'requestsBlocked',
        minWidth: 100,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.requestsTotal'),
        accessor: 'requestsTotal',
        minWidth: 100,
        filterable: false,
        sortable: true,
        isShow: true,
      },
      {
        Header: I18n.t('organizations.profiles.table.headers.actions'),
        accessor: 'actions',
        Cell: this.actionsCellRenderer,
        minWidth: 50,
        filterable: false,
        sortable: false,
        isShow: true,
      },
    ];
  }

  render() {
    const {
      classes,
      mode,
      isEditMode,
      tableData,
    } = this.props;

    return (
      <LoadingLayout widgetKey={widgetKeys.ORGANIZATION_PROFILES_STATS}>
        <EntitiesListWithViewModesCard
          mode={mode}
          headersFullWidthMode={this.fullScreenColumns}
          tableData={tableData}
          disabled={isEditMode}
          title={I18n.t('organizations.profiles.table.title')}
          customClasses={classes}
          fullscreen={false}
          // additionalHeaderActions={...}  //TODO: Add profile button should be here
          componentHeaderHidden={true}
        />
      </LoadingLayout>
    );
  }
}

OrganizationProfilesTable.propTypes = {
  classes: PropTypes.object,
  isEditMode: PropTypes.bool,
  mode: PropTypes.string,
  tableData: PropTypes.array,
  tableStyles: PropTypes.object,
  removeProfileFromOrganization: PropTypes.func.isRequired,
};

OrganizationProfilesTable.defaultProps = {
  classes: {},
  isEditMode: false,
  mode: '',
  tableData: [],
  tableStyles: {},
};

export default withStyles(style)(OrganizationProfilesTable);
